import React from "react";
import MegaMenu from "@insightfulscience/atomic-react/MegaMenu";
import MegaMenuTitle from "@insightfulscience/atomic-react/MegaMenu/Title";
import MegaMenuItem from "@insightfulscience/atomic-react/MegaMenu/Item";
import { MegaMenuCol } from "@insightfulscience/atomic-react/MegaMenu/Grid";
import { useLocale } from "@insightfulscience/i18";
import routes from "@src/routes";

const SolutionsDropdown = () => {
	const [t] = useLocale("common");

	return (
		<MegaMenu>
			<MegaMenuCol lg={4} md={12} spacing={{ lg: { ml: 48 } }}>
				<MegaMenuTitle uppercase>{t("MENU.SOLUTIONS")}</MegaMenuTitle>
				<MegaMenuItem>
					<MegaMenuItem.Link
						href={routes.solutions.subRoutes.enterprise.url}
						className="nav__item-link"
					>
						{t("MENU.dropdown.solutions.ENTERPRISE")}
					</MegaMenuItem.Link>
					<MegaMenuItem.Description>
						{t("MENU.dropdown.solutions.ENTERPRISE_DESCRIPTION")}
					</MegaMenuItem.Description>
				</MegaMenuItem>
				<MegaMenuItem>
					<MegaMenuItem.Link
						href={routes.solutions.subRoutes.customAutogating.url}
						className="nav__item-link"
					>
						{t("MENU.dropdown.solutions.CUSTOM_AUTOGATING")}
					</MegaMenuItem.Link>
					<MegaMenuItem.Description>
						{t("MENU.dropdown.solutions.CUSTOM_AUTOGATING_DESCRIPTION")}
					</MegaMenuItem.Description>
				</MegaMenuItem>
				<MegaMenuItem>
					<MegaMenuItem.Link
						href={routes.solutions.subRoutes.omiqLuma.url}
						className="nav__item-link"
					>
						{t("MENU.dropdown.solutions.OMIQ_LUMA")}
					</MegaMenuItem.Link>
					<MegaMenuItem.Description>
						{t("MENU.dropdown.solutions.OMIQ_LUMA_DESCRIPTION")}
					</MegaMenuItem.Description>
				</MegaMenuItem>
			</MegaMenuCol>
		</MegaMenu>
	);
};

export default SolutionsDropdown;
